/**
 * Format price for display
 *
 * Task: T-P4-D2-F3e-8 (consistency fix)
 *
 * Standardizes price display across all Hub surfaces:
 * - null or 0 → "Free"
 * - Whole numbers → "$45"
 * - Decimals → "$45.50"
 */
export function formatPrice(price: number | null): string {
  if (price === null || price === 0) return 'Free';
  return formatDollarAmount(price);
}

/**
 * Format a USD amount without changing its monetary precision:
 * whole dollars stay compact, while any cents always render as two digits.
 */
export function formatDollarAmount(amount: number): string {
  const fractionDigits = Number.isInteger(amount) ? 0 : 2;
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: 2,
  }).format(amount);
}

/**
 * Format price with duration for service display
 * e.g., "60 min • $45" or "60 min • Free"
 */
export function formatServiceMeta(duration: number, price: number | null): string {
  return `${duration} min • ${formatPrice(price)}`;
}
